import { NavigateOptions, useNavigate } from "react-router-dom";
import { TransactionsRoutes } from "../router/TransactionsRouter";
import { SendState } from "../transactions.types";

export default function useNavigateWithSendState(route: TransactionsRoutes) {
    const navigate = useNavigate();

    function handleSubmit(sendState: SendState, options: Omit<NavigateOptions, "state"> = {}) {
        navigate(route, {
            state: {
                sendState,
            },
            ...options,
        });
    }

    return handleSubmit;
}
